import { ChakraProvider } from "@chakra-ui/react";
import Router from "./components/Router";

// This is the main App component for the static landing site
const App = () => {
  return (
    <ChakraProvider>
      <Router />
    </ChakraProvider>
  );
};

export default App;
